import * as React from 'react'

import type { Field } from 'factorial-form'

import ColorPicker from 'modules/core/components/Inputs/ColorPicker'

import { COLOR_CODES } from 'modules/timeoff/store/models/LeaveType'

interface Props {
  field: Field
}

const Color = ({ field }: Props) => {
  const leaveTypeColor = field.originalValue || field.value

  const colors = COLOR_CODES.includes(leaveTypeColor)
    ? COLOR_CODES
    : [leaveTypeColor, ...COLOR_CODES]

  return <ColorPicker name="leaveTypeColor" field={field} colors={colors} />
}

export default Color
